import React from 'react';
import { useTranslation } from '../../../../contexts/I18nProvider';

/**
 * Viser ordretypen (POrders.OrderType) som «OT: <verdi>» i varemottak (TW 36420288).
 *
 * - Verdien vises rå, uten oversetting — den kommer fra ERP og er fritekst.
 * - «Retur» utheves fordi den krever annen håndtering enn vanlig mottak.
 * - Tom ordretype gir ingenting (ikke «OT:» uten verdi).
 * - whitespace-nowrap + flex-shrink-0: badgen kuttes aldri; forelderen må ha flex-wrap
 *   slik at den brytes til ny linje på smale skjermer i stedet for å forsvinne.
 */
export const OrderTypeBadge: React.FC<{ orderType?: string | null; className?: string }> = ({ orderType, className = '' }) => {
  const { t } = useTranslation();
  const value = orderType?.trim();
  if (!value) return null;

  const isReturn = value.toLowerCase().startsWith('retur');
  const prefix = t('warehouse.modules.receipt.list.orderTypePrefix', {}, 'OT');

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap flex-shrink-0 text-xs ${
        isReturn ? 'px-1.5 py-0.5 rounded bg-red-100 text-red-700 font-bold' : 'text-gray-600 font-medium'
      } ${className}`}
    >
      {prefix}: {value}
    </span>
  );
};
